import React, { lazy, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import TopActions from './TopActions';
import ParentStyled from './style';
import { loadStyle, hasValue, objectArrayFromDiffFields } from 'globalutils/fmUtils';

const Styled = loadStyle(ParentStyled, 'pages/web/RadiusComplianceAlerts/Component');
const layout = window?.$environment?.CURRENT_LAYOUT;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => (
  <Box style={{ ...theme.palette.contentStyle }}>
    <Breadcrumb filters={filters} />
    <Component {...contentProps} />
  </Box>
);

export default Index;

const Component = ({
  list,
  filterSuccess,
  selectedCompany,
  apiStatus,
  apiIds,
  needFilter,
  i18n,
  columns,
  topAction,
  defaultSortBy,
  pagination,
  setPagination,
  fleetCompanies,
}) => {
  const [openModalDesc, setModalDesc] = useState(false);
  const [modalDescData, setModalDescData] = useState({ header: '', content: () => <></> });

  const hasApiStatus = hasValue(apiStatus?.status, 'api', apiIds.list);
  const information = hasApiStatus?.errorMessage ? (
    <Message type="error" message={hasApiStatus.errorMessage} />
  ) : (
    i18n.t('No data available')
  );

  const fleetCompanyList = objectArrayFromDiffFields(fleetCompanies, 'id', 'name');
  const selectedCompanyList = objectArrayFromDiffFields(selectedCompany, 'id', 'name');

  const descColumns = [
    {
      id: 'description',
      disablePadding: false,
      label: i18n.t('dashboard.tabs.radiusComplianceAlerts.description'),
      needSorting: true,
    },
    {
      id: 'date',
      disablePadding: false,
      label: i18n.t('dashboard.tabs.radiusComplianceAlerts.date'),
      needSorting: true,
    },
  ];

  const generateRows = () => {
    return list.filteredList.map((ele) => {
      if (ele.descriptions.length > 1) {
        ele.description = (
          <div className="descPopUp" onClick={() => handleDescPopup(ele)}>
            {getAlertTypeLabel(ele.type, i18n)}
          </div>
        );
      } else if (ele.descriptions.length === 1) {
        ele.description = ele.descriptions[0]?.description;
      }
      return ele;
    });
  };

  const generateDescRows = (list) => {
    return list.map((ele) => {
      const date = new Date(Date.UTC(
        new Date(ele.date).getFullYear(),
        new Date(ele.date).getMonth(),
        new Date(ele.date).getDate(),
        new Date(ele.date).getHours(),
        new Date(ele.date).getMinutes()
      ));
      ele.date = moment(date).format('MM/DD/YYYY HH:mm:ss');
      return ele;
    });
  };

  const handleDescPopup = (data) => {
    setModalDesc(true);
    setModalDescData({
      content: () => (
        <div className="descModal">
          <div className="headWrapper">{data.companyName}</div>
          <Table
            type="client"
            defaultSortBy={{ sortBy: 'date', order: 'desc' }}
            title=""
            columns={descColumns}
            data={generateDescRows(data.descriptions)}
            emptyMessage={information}
            itemsPerPage={5}
            id="dashBoardAlertsDescriptionPopUp"
            actions={[]}
            i18n={i18n}
          />
        </div>
      ),
    });
  };

  const getAlertTypeLabel = (type, i18n) => {
    if (type.toLowerCase().includes('radius')) return i18n.t('multipleRadiusAlert');
    if (type.toLowerCase().includes('accident')) return i18n.t('multipleAccidentAlert');
    if (type.toLowerCase().includes('dvir')) return i18n.t('multipleDvirAlert');
    return i18n.t('multipleAlert');
  };

  return (
    <>
      {topAction && (
        <TopActions
          {...{
            filterSuccess,
            selectedCompanyList,
            i18n,
            needFilter,
            list,
            setPagination,
            Styled,
            fleetCompanyList,
          }}
        />
      )}
      <Styled.TableWrapper>
        <Table
          type="client"
          defaultSortBy={defaultSortBy || { sortBy: 'date', order: 'desc' }}
          title=""
          columns={columns}
          data={generateRows()}
          emptyMessage={information}
          itemsPerPage={15}
          actions={[]}
          i18n={i18n}
          pageinationReset={pagination}
          pagenationClicked={(e) => setPagination(!e)}
        />
      </Styled.TableWrapper>
      <Modal
        open={openModalDesc}
        setOpen={setModalDesc}
        data={modalDescData}
        deletePopup
        withCloseIcon
        width="800px"
        alignItemsLeft
      />
    </>
  );
};

Component.propTypes = {
  list: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  apiStatus: PropTypes.object.isRequired,
  exportAllData: PropTypes.func.isRequired,
  deleteData: PropTypes.func.isRequired,
};
